// Allows for smooth scrolling in safari.
// _body.scss has the style for controlling the scroll behaviour
import smoothscroll from 'smoothscroll-polyfill';
import 'smoothscroll-anchor-polyfill';
smoothscroll.polyfill();
